import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name || !formData.phone || !formData.email || !formData.message) {
      alert("Please fill in all fields before submitting.");
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch("https://www.sreenathji.com/send-contact-mail.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok && result.status === "success") {
        alert("✅ Your message has been sent successfully!");
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      } else {
        alert("❌ Failed to send your message. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("⚠️ Something went wrong. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        {/* Left Content */}
        <div className="contact-info">
          <h2>Questions? Ask!</h2>
          <p>
            Fill in your information and we will get back to you as quickly as possible. <br />
            Or just give us a call at{" "}
            <span className="link">
              <a href="tel:+919972812736">+91-99728 12736</a>
            </span>
          </p>
        </div>

        {/* Right Form */}
        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Name*"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <input
              type="text"
              name="phone"
              placeholder="Phone*"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <textarea
              name="message"
              placeholder="Enter your questions here*"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>

            <button type="submit" className="cta-btn" disabled={submitting}>
              {submitting ? "Sending..." : "Ask Question"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
